export default {"src":"https://www.bulletproof.co.uk/_next/static/media/bg-dots.8b8cf260.svg","height":488,"width":916,"blurWidth":0,"blurHeight":0};